<div class="modal-header">
  <h3 class="modal-title normal-text center">{{ 'Input PIN' | translate }}</h3>
  <button type="button" class="close" (click)="closeClick()">
    <span aria-hidden="true">×</span>
  </button>
</div>
<div class="modal-body" style="display: block; max-height: 88%; margin-top: 1rem;">
  <div class="pin-container flex-column flex-sm-row">
    <div class="col-12 col-sm-4">
      <div>
        <app-pin-pad (keyClick)="onKeyClick($event)" (keyDeleteClick)="onKeyDeleteClick()"></app-pin-pad>
      </div>
    </div>
    <div class="col-2">
      <br />
    </div>
    <div class="col-12 col-sm-6">
      <div class="pin-information-wrapper">
        <div class="col-12 pin-information">
          <p>{{ 'Please enter your PIN' | translate }}</p>
          <p>
            <!-- <span>for a guided tour! / für eine Führung ein!</span> -->
          </p>
          <br>
          <p class="pin">{{hiddenPin}}</p>
          <br>
          <p class="invalid-pin-message">
            <span *ngIf="showInvalidPinMessage">{{ 'Incorrect PIN' | translate }}</span>
          </p>
          <br>
          <button type="button" class="btn btn-primary btn-dialog" (click)="confirmClick()" cdkFocusInitial>{{ 'Confirm'
            | translate }}</button>
        </div>
      </div>
    </div>
  </div>
</div>
